<div class="flex flex-col gap-6 lg:gap-10 px-4 lg:px-0 lg:max-w-6xl lg:mx-auto py-6 lg:py-12 w-full">
  <!-- 검색 및 TOTAL 영역 -->
  <div class="flex flex-col gap-3 lg:flex-row lg:justify-between lg:items-center">
    <!-- TOTAL -->
    <div class="flex items-center gap-1">
      <span class="text-zinc-800 sb-aggro text-sm font-light">TOTAL</span>
      <span class="text-orange-500 sb-aggro font-light text-sm">
        {{ totalCount() }}
      </span>
    </div>

    <!-- 검색창 -->
    <div class="search-box">
      <app-icon name="ic:round-search" class="size-5! text-zinc-400"></app-icon>
      <input type="text" placeholder="검색어를 입력하세요" [value]="query()" (input)="onSearch($event)" />
    </div>
  </div>

  <!-- 갤러리 그리드 -->
  <div class="grid grid-cols-1 lg:grid-cols-4 gap-6">
    @for (item of galleryList(); track item.id) {
    <a [routerLink]="[item.id]" class="flex flex-col gap-3 cursor-pointer group">
      <!-- 썸네일 -->
      <div class="relative w-full aspect-square bg-zinc-900 rounded-xl overflow-hidden">
        @if (getThumbnail(item); as thumbnail) {
        <img [src]="thumbnail" [alt]="getTypeLabel(item.type)" class="w-full h-full object-cover" />
        }
        <!-- 타입 배지 -->
        <div
          class="absolute top-3 left-3 px-2 py-1 bg-black/60 backdrop-blur-sm rounded text-white text-xs font-medium">
          {{ getTypeLabel(item.type) }}
        </div>
        <!-- 비디오 아이콘 -->
        @if (item.type === 'VIDEO') {
        <div class="absolute inset-0 flex items-center justify-center">
          <app-icon name="mdi:play-circle" class="size-16! text-white/80" />
        </div>
        }
      </div>

      <!-- 정보 -->
      <div class="flex justify-between items-start gap-2">
        <div class="flex flex-col gap-1">
          <span class="sb-aggro text-lg text-zinc-800 font-light line-clamp-2">
            {{ item.title }}
          </span>
          <span class="text-sm text-zinc-400 font-medium">
            {{ item.displayDate || item.createdAt | date : 'yyyy.MM.dd' }}
          </span>
        </div>
        <app-icon
          name="material-symbols:arrow-outward-rounded"
          class="size-5! text-zinc-400 group-hover:text-orange-500 transition-colors" />
      </div>
    </a>
    }
  </div>

  <!-- 데이터 없음 -->
  @if (galleryList().length === 0) {
  <app-not-found [(query)]="query" [isLoading]="$galleryData.isLoading()">
    <span class="sb-aggro text-zinc-800 text-lg font-light">갤러리가 없습니다.</span>
  </app-not-found>
  }
</div>

<!-- 페이지네이션 -->
@if (galleryList().length > 0) {
<app-pagination
  [currentPage]="currentPage()"
  [totalPages]="totalPages()"
  (pageChange)="onPageChange($event)"
  class="flex" />
}
